// extracted by mini-css-extract-plugin
module.exports = {"password":"hurQ-","label":"J+aZ6","input":"V6bqg","strenght":"_5mXXo","options":"_8XPug"};